export default __webpack_public_path__ + "static/media/carico.d031608f.svg";